import { useContext } from "react";

import { ScalesContext } from "../../context/ScalesContext/ScalesContext";

import Input from "../../atoms/Input";
import ActionButton from "../../atoms/ActionButton";

import DeleteIcon from "../../assets/imgs/icons/deleteWhite.svg";
import Arrow from "../../assets/imgs/icons/arrowUpCircleWhite.svg";

import styles from "./newSectionOption.module.scss";

const NewSectionOption = ({ ...props }) => {
  const {
    deleteOption,
    id,
    name,
    setIsAccordeonOpen,
    isAccordeonOpen,
  } = props;
  const { isEditable, hasPlans, hasResponses } = useContext(ScalesContext);
  const disabled = !isEditable | hasPlans | hasResponses;

  return (
    <div className={styles.newSectionContainer}>
      <div className={styles.inputContainer}>
        <Input
          name={name}
          type="text"
          disabled={disabled}
          placeholder="Nueva sección"
          variant="white"
        />
      </div>
      <div className={styles.newSectionActionButtons}>
        <ActionButton
          icon={DeleteIcon}
          onClick={() => deleteOption(id)}
          disabled={disabled}
        />
        <ActionButton
          icon={Arrow}
          onClick={() => setIsAccordeonOpen(!isAccordeonOpen)}
        />
      </div>
    </div>
  );
};

export default NewSectionOption;
